import { GlLink, GlModal, GlButton, GlModalDirective, GlLoadingIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_ISSUE, TYPE_MERGE_REQUEST } from '~/issues/constants';
import { BV_SHOW_MODAL } from '~/lib/utils/constants';
import { s__, __ } from '~/locale';
import { timeTrackingQueries } from '../../queries/constants';
import eventHub from '../../event_hub';
import TimeTrackingCollapsedState from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/time_tracking/collapsed_state.vue?vue3';
import TimeTrackingComparisonPane from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/time_tracking/comparison_pane.vue?vue3';
import TimeTrackingSpentOnlyPane from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/time_tracking/spent_only_pane.vue?vue3';
import TimeTrackingReport from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/time_tracking/time_tracking_report.vue?vue3';
import { CREATE_TIMELOG_MODAL_ID, SET_TIME_ESTIMATE_MODAL_ID } from './constants';
import CreateTimelogForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/time_tracking/create_timelog_form.vue?vue3';
import SetTimeEstimateForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/sidebar/components/time_tracking/set_time_estimate_form.vue?vue3';
export default {
    name: 'IssuableTimeTracker',
    i18n: {
        noTimeTrackingText: __('No estimate or time spent'),
        estimatedOnlyText: s__('TimeTracking|Estimated:'),
        addTimeEntryText: s__('TimeTracking|Add time entry')
    },
    components: {
        GlLink,
        GlModal,
        GlButton,
        GlLoadingIcon,
        TimeTrackingCollapsedState,
        TimeTrackingSpentOnlyPane,
        TimeTrackingComparisonPane,
        TimeTrackingReport,
        CreateTimelogForm,
        SetTimeEstimateForm
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    inject: {
        issuableType: {
            default: null
        }
    },
    props: {
        limitToHours: {
            type: Boolean,
            default: false,
            required: false
        },
        fullPath: {
            type: String,
            required: false,
            default: ''
        },
        issuableId: {
            type: String,
            required: false,
            default: ''
        },
        issuableIid: {
            type: String,
            required: false,
            default: ''
        },
        initialTimeTracking: {
            type: Object,
            required: false,
            default: null
        },
        /*
      In issue list, "time-tracking-collapsed-state" is always rendered even if the sidebar isn't collapsed.
      The actual hiding is controlled with css classes:
        Hide "time-tracking-collapsed-state"
          if .right-sidebar .right-sidebar-collapsed .sidebar-collapsed-icon
        Show "time-tracking-collapsed-state"
          if .right-sidebar .right-sidebar-expanded .sidebar-collapsed-icon

      In Swimlanes sidebar, we do not use collapsed state at all.
    */ showCollapsed: {
            type: Boolean,
            default: true,
            required: false
        },
        canAddTimeEntries: {
            type: Boolean,
            required: false,
            default: true
        },
        canSetTimeEstimate: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            timeTracking: {
                ...this.initialTimeTracking
            }
        };
    },
    apollo: {
        // eslint-disable-next-line @gitlab/vue-no-undef-apollo-properties
        issuableTimeTracking: {
            query () {
                return timeTrackingQueries[this.issuableType].query;
            },
            skip () {
                // Skip the query if either of the conditions are true
                // 1. issuableType is not provided
                // 2. Time tracking info was provided via prop
                // 3. issuableIid and fullPath are not provided
                if (!this.issuableType || !timeTrackingQueries[this.issuableType]) {
                    return true;
                }
                if (this.initialTimeTracking) {
                    return true;
                }
                if (!this.issuableIid || !this.fullPath) {
                    return true;
                }
                return false;
            },
            variables () {
                return {
                    iid: this.issuableIid,
                    fullPath: this.fullPath
                };
            },
            update (data) {
                this.timeTracking = {
                    ...data.namespace?.issuable
                };
            }
        }
    },
    computed: {
        isTimeTrackingInfoLoading () {
            return this.$apollo.queries.issuableTimeTracking.loading;
        },
        timeEstimate () {
            return this.timeTracking?.timeEstimate || 0;
        },
        totalTimeSpent () {
            return this.timeTracking?.totalTimeSpent || 0;
        },
        humanTimeEstimate () {
            return this.timeTracking?.humanTimeEstimate || '';
        },
        humanTotalTimeSpent () {
            return this.timeTracking?.humanTotalTimeSpent || '';
        },
        hasTotalTimeSpent () {
            return Boolean(this.totalTimeSpent);
        },
        hasTimeEstimate () {
            return Boolean(this.timeEstimate);
        },
        showComparisonState () {
            return this.hasTimeEstimate && this.hasTotalTimeSpent;
        },
        showEstimateOnlyState () {
            return this.hasTimeEstimate && !this.hasTotalTimeSpent;
        },
        showSpentOnlyState () {
            return this.hasTotalTimeSpent && !this.hasTimeEstimate;
        },
        showNoTimeTrackingState () {
            return !this.hasTimeEstimate && !this.hasTotalTimeSpent;
        },
        isTimeReportSupported () {
            return [
                TYPE_ISSUE,
                TYPE_MERGE_REQUEST
            ].includes(this.issuableType) && this.issuableId;
        },
        timeEstimateTooltip () {
            return this.hasTimeEstimate ? s__('TimeTracking|Edit estimate') : s__('TimeTracking|Set estimate');
        }
    },
    watch: {
        /**
     * When `initialTimeTracking` is provided via prop,
     * we don't query the same via GraphQl and instead
     * monitor it for any updates (eg; Epic Swimlanes)
     */ initialTimeTracking (timeTracking) {
            this.timeTracking = timeTracking;
        }
    },
    created () {
        eventHub.$on('time-tracker-refresh', this.refresh);
    },
    methods: {
        refresh () {
            this.$apollo.queries.issuableTimeTracking.refetch();
        },
        openRegisterTimeSpentModal () {
            this.$root.$emit(BV_SHOW_MODAL, CREATE_TIMELOG_MODAL_ID);
        }
    },
    setTimeEstimateModalId: SET_TIME_ESTIMATE_MODAL_ID
};
